import { h, Component } from 'preact';

class FitTextOneLine extends Component {
    state = { fontPx: 16 };
    setBox = el => { this.box = el; };
    setSpan = el => { this.span = el; };
    raf = 0;

    componentDidMount() { this.scheduleUpdate(); }
    componentDidUpdate(prev) {
        if (prev.text !== this.props.text || prev.widthMm !== this.props.widthMm) {
            this.scheduleUpdate();
        }
    }
    componentWillUnmount() { cancelAnimationFrame(this.raf); }

    scheduleUpdate() {
        cancelAnimationFrame(this.raf);
        this.raf = requestAnimationFrame(() => this.update());
    }

    update() {
        const { text, minPx = 6, maxPx = 48 } = this.props;
        if (!this.box || !this.span || !text) return;

        const target = this.box.clientWidth; // actual rendered width in px
        if (!target) {                       // not laid out yet → try next frame
            this.scheduleUpdate();
            return;
        }

        // binary search largest font that fits
        let lo = minPx, hi = maxPx, best = minPx;
        while (lo <= hi) {
            const mid = Math.floor((lo + hi) / 2);
            this.span.style.fontSize = `${mid}px`;
            const w = this.span.scrollWidth;
            if (w <= target) { best = mid; lo = mid + 1; } else { hi = mid - 1; }
        }
        if (best !== this.state.fontPx) this.setState({ fontPx: best });
    }

    render() {
        const { text, widthMm = 60, className = '' } = this.props;
        if (!text) return null;
        return (
            <div
                ref={this.setBox}
                class={className}
                style={`width:${widthMm}mm; white-space:nowrap; overflow:hidden; line-height:1.2;`}
            >
                <span
                    ref={this.setSpan}
                    style={`display:inline-block; font-size:${this.state.fontPx}px;`}
                    title={text}
                >{text}</span>
            </div>
        );
    }
}

export default FitTextOneLine;
